import styled from 'styled-components';

export const StyledName = styled.h1`
  font-family: 'Charlotte';
  font-size: 4rem;
  font-weight: 70;
  padding: 1%;
  margin-top: 0%;
  margin-bottom: 0%;
  padding-bottom: 1%;
  color: ${props => (props.color ? props.color : '#e2e1e1')};
`;

export const StyledNameSmall = styled.h5`
  font-family: 'Fecske';
  font-size: 2rem;
  font-weight: 15;
  padding: 1%;
  margin-top: 0%;
  margin-bottom: 0%;
  padding-bottom: 1%;
  color: ${'#006d46'};
`;

export const StyledText = styled.p`
  font-family: 'Fecske';
  margin: 0.5rem 0 0 0;
  font-size: 2.2rem;
  color: ${props => (props.color ? props.color : '#e2e1e1')};
`;

export const StyledTextTitle = styled.p`
  font-family: 'Fecske';
  margin: 0.5rem 0 0 0;
  font-size: 1.5rem;
  color: ${props => (props.color ? props.color : '#e2e1e1')};
`;

export const StyledTextTitleZ = styled.p`
  font-family: 'Charlotte';
  margin: 0.5rem 0 0 0;
  font-size: 3rem;
  color: ${props => (props.color ? props.color : '#e2e1e1')};
`;

export const StyledTextSubTitle = styled.p`
  font-family: 'Fecske';
  margin: 0.5rem 0 0 0;
  font-size: 1.5rem;
  color: ${props => (props.color ? props.color : '#e2e1e1')};
`;

export const StyledTextButton = styled.p`
  color: ${props => (props.color ? props.color : '#e2e1e1')};
`;
export const NavWrapper = styled.div`
  font-family: 'Fecske';
  padding-top: 0.75em;
  display: flex;
  text-align: center;
  flex-wrap: nowrap;
  background: -o-linear-gradient(transparent, transparent);
  justify-content: center;
  & .nav-span {
    color: #006d46 !important;
    margin: 5px;
    padding: 4px;
    border-style: solid;
    border-width: 1px 1px 1px 1px;
    padding: 12px 30px 12px 32px;
    border-radius: 10px;
    background-color: '#e2e1e1';
  }
`;
